module.exports = __webpack_public_path__ + "img/clickCursor.ff1efa0c.svg";